export default __webpack_public_path__ + "static/houses_3-c5ddc0907729ca03cc6804f8db8f26ae.png";